import { useEffect, useState, useCallback , useRef } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import InputMask from 'react-input-mask';
//import { GinecologiaRecord } from './GinecologiaRecord';
import Webcam from "react-webcam";
import moment from "moment";
import DatePicker from "react-datepicker";

import * as XLSX from "xlsx"
import { saveAs } from "file-saver";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './FT.css';
import emailjs from '@emailjs/browser';



const modeloDatos = {
    pacienteID:0,
    empresaid: 0
    , nombres: ''
    , apellidos: ''
    , cedula: ''
    , telefono: ''
    , celular: ''
    , fechaNacimiento: new Date
    , sexo: ''
    , tipoOrden: 0
    , seguroID: 0
    , nombreSeguro: ''
    , poliza: ''
    ,centroID:0
    , diagnostico: ''
    , diagnosticoClinico: ''
    , direccion: ''
    , tratamientoID: 0
    , nombreTratamiento: ''
    , resultado: ''
    , toxicos: ''
    , creadoPor: ''
    , fechaCreado: new Date
    , modificadoPor: ''
    , fechaModificado: new Date
    , imagen: ''
    , alergicos: ''
    , antecedentesMedicos: ''
    , antecedentesMedicamentos: ''
    , examenFisico: ''
    , antecedentesFamiliares: ''
    , habitosAlimenticios: ''


}
const modeloRecord = {
    recordPacienteGastroID: 0,
    empresaID: 1,
    pacienteID: 0,
    historiaClinica: '',
    comentario: '',
    fecha:new Date
}
const modeloReceta = {
    recetaID: 0,
    empresaID: 1,
    pacienteID: 0,
    recordPacienteID: 0,
    medicamentoID: 0,
    nombreMedicamento: '',
    fecha: new Date,
    comentario: '',
    fechaCreado: new Date,
    creadoPor: '',
    dosificacion:''
}
let options = [];
let optionsT = [{ descripcion: "" }];
let NombreSe = '';
const ReportesGastro = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [Seguro, setSeguro] = useState(0);
    const [NombreSe, setNombreSe] = useState('');
    const [Listado, SetListado] = useState([]);
    const [ListadoTox, SetListadoTox] = useState([]);
      const [pendiente, setPendiente] = useState(true);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Empresa, SetEmpresa] = useState(window.localStorage.getItem("Empresa"))
    const [Listado1, SetListado1] = useState([]);
    const [paciente, Setpaciente] = useState([]);
    const [Camara, SetCamara] = useState(false);
    const [ListadoSeg, SetListadoSeg] = useState([]);

    const [Inicio, SetInicio] = useState(false);
    const [url, Seturl] = useState(false);

   
    //toast.configure();
    const Rp = [
        {
            "id": 1,
            "nombre": "Producto A",
            "precio": 100.50,
            "precio1": 100.50
        },
        {
            "id": 2,
            "nombre": "Producto B",
            "precio": 200.75,
            "precio1": 200.75
        },
        {
            "id": 3,
            "nombre": "Producto C",
            "precio": 150.00,
            "precio1": 150.00
        }
    ]


    let correo = JSON.parse(user).correo;
    const onBusqueda = async (e) => {
        var l = Listado1;
       
        console.log(e);
        var searchData = l.filter((item) => {
            if (
                (item.nombres + item.apellidos + item.cedula + item.telefono)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

    


    const obtenerDatos = async () => {
        let fi = moment(fechaInicio).format("YYYY-MM-DD");
        let ff = moment(fechaFin).format("YYYY-MM-DD");

        let response = await fetch(Api + "Pacientes/ListaReporteAtendido/" + fi + "/" + ff + "/" + Seguro + "/" + JSON.parse(user).empresaID);

        if (response.ok) {
            let data = await response.json()
        
            SetListado(data);
            var url = window.location.origin + "/descarga/1/" + fi + "/" + ff + "/" + Seguro + "/" + JSON.parse(user).empresaID;
           
            Seturl ( url);
        }
    }

     useEffect(() => {
            obtenerDatosToxico();
            obtenerDatosSeg();
    }, [])

    useEffect(() => {
        obtenerDatos();
        if (ListadoSeg.length > 0) {
 setNombreSe(ListadoSeg.find(x => x.seguroID == Seguro).descripcion);
        }
       
      
    }, [Seguro])   
    

      

    
    const webcamRef = useRef(null);
    const capture = useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            SetCamara(false)
        
            tabla.imagen = imageSrc;
            document.getElementsByName("imagen").value = imageSrc;
        },
        [webcamRef]
  
    );


    const obtenerDatosToxico = async () => {
        let response = await fetch(Api + "CMantenimiento/listaToxicos");
        if (response.ok) {
            let data = await response.json()
            SetListadoTox(data)
      
        }
    }



    const obtenerDatosSeg = async () => {
        let response = await fetch(Api + "CMantenimiento/ListaSeguros/dr/1");
        if (response.ok) {
            let data = await response.json()
            SetListadoSeg(data)
        }
    }
    const exportarExcel = async () => {
        //var wb = XLSX.utils.book_new();


        //var ws = XLSX.utils.json_to_sheet(Listado);
        //XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        //XLSX.writeFile(wb, "Reporte Factura NCF"+ ".xlsx")
       
        let fi = moment(fechaInicio).format("YYYY-MM-DD");
        let ff = moment(fechaFin).format("YYYY-MM-DD");
    // Crear una hoja de cálculo
        const ws = XLSX.utils.json_to_sheet(Listado);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Hoja1");

    // Convertir el archivo en Blob
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Crear FormData para enviarlo al backend
        const formData = new FormData();
        formData.append("file", blob, "Reclamaciones" + fi + "-" + ff + "-" + Seguro +  ".xlsx");

    // Enviar al backend (API en C#)
        const response = await fetch(Api + "Pacientes/upload", {

        method: "POST",
        body: formData,
    });

    const result = await response.json();
    alert(`Archivo guardado. URL: ${result.fileUrl}`);
       
        sendEmail(result.fileUrl);
    }
  

    const [formData, setFormData] = useState({
            name: " desde " + moment(fechaInicio).format("YYYY-MM-DD") + " al " + moment(fechaFin).format("YYYY-MM-DD") + "-" + NombreSe          ,
        email: "info@apatech.com.do",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const sendEmail = (e) => {
       
     //   e.preventDefault();
        Swal.fire({
            title: 'Ingrese el correo',
            input: 'email', // Define el campo como email (para navegadores compatibles)
            inputPlaceholder: 'ejemplo@correo.com',
            inputValue: 'info@apatech.com.do',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            inputValidator: (valor) => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!valor) {
                    return 'Debe ingresar un correo';
                } else if (!emailRegex.test(valor)) {
                    return 'Ingrese un correo válido';
                }
                return null;
            }
        }).then((result) => {
            if (result.isConfirmed) {
         
                             
               
        emailjs
            .send(
                "service_95lb0aa",  // Reemplaza con tu Service ID
                "template_bh6vxni", // Reemplaza con tu Template ID
                {
                    to_email: result.value,
                    from_name: formData.name +"-" + NombreSe,
                    message: url,
                    Empresa: Empresa
                },
                "Ya-bX4GMQA3dqWVnz" // Reemplaza con tu Public Key
            )
            .then(
                (response) => {
                    Swal.fire(
                        'Se ha enviado el correo a: ' + result.value,
                        '',
                        'success'
                    )
                },
                (error) => {
                    alert("Error al enviar el correo.");
                }
                    );
                }

               

        })
    };


    return (
        <>
         
            <ToastContainer />
                 

                  
                   
                <Col md="12" hidden={paciente.length != 0}>
                <Card>
                   
                        <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                            <Row>
                            <Col sm={2}>
                                <FormGroup>
                                    <Label style={{color:"#fff"} } ><b>Fecha Inicio:</b></Label>
                                    <DatePicker
                                        className="form-control form-control-sm"
                                        selected={fechaInicio}
                                        onChange={(date) => setFechaInicio(date)}
                                        dateFormat='dd/MM/yyyy'
                                    />
                                </FormGroup>
                            </Col>

                            <Col sm={2}>
                                <FormGroup>
                                    <Label style={{ color: "#fff" }}><b>Fecha Fin:</b></Label>
                                    <DatePicker
                                        className="form-control form-control-sm"
                                        selected={fechaFin}
                                        onChange={(date) => setFechaFin(date)}
                                        dateFormat='dd/MM/yyyy'
                                    />
                                </FormGroup>
                            </Col>
                            <Col sm={2}>
                                <FormGroup >
                                    <Label style={{ color: "#fff" }}><b>Seguro:</b></Label>
                                    <Input bsSize="sm" type={"select"} className="form-control" onChange={(e) => setSeguro(e.target.value) }>
                                        <option value={0}>Todo </option>
                                        {ListadoSeg.map(x => <option value={x.seguroID}> {x.descripcion}</option>)}

                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={3}>
                                <FormGroup>
                                    <Label style={{ color: "#fff" }}><b>Buscar en rango de fecha</b></Label>

                                    <Button color="success" size="sm" block onClick={()=>obtenerDatos()}>
                                        <i className="fa fa-search" aria-hidden="true"></i> Buscar
                                    </Button>
                                </FormGroup>
                            </Col>
                            <Col sm={1}>
                                <FormGroup>
                                    <label>.</label>
                                    {(JSON.parse(user).empresaID == 1)&&  <Button color="warning" size="md" hidden={Listado.length == 0}
                                        onClick={()=>sendEmail() }
                                    ><i className="fas fa-envelope"></i></Button>}
                                </FormGroup>
                            </Col>
                                    <Col sm={1}>
                                <FormGroup>
                                    <label>.</label>
                                    <Button color="warning" size="md"
                                        href="/Gastro"
                                    ><b>Salir</b></Button>
                                </FormGroup>
                            </Col>
                            
                  </Row>
                    </CardHeader>
                    <CardBody style={{ padding: "0px"} }>

                        <table className="table">
                            <tr>
                            <th>No.</th>
                            <th>Nombre</th>
                            <th>Telefono</th>
                            <th>Celular</th>
                                <th>Seguro</th>
                            <th>Poliza</th>
                            <th>Historia</th>
                            </tr>
                            {Listado.map((x, rowID) => (
                                <tr key={rowID }>
                                    <td style={{ padding: "10px 0px 0px 4px" }}>{rowID + 1 }</td>
                                    <td style={{ padding: "10px 0px 0px 4px" }}>{x.nombres + ' ' + x.apellidos}</td>
                                    <td style={{ padding: "10px 0px 0px 4px" }}>{x.telefono }</td>
                                    <td style={{ padding: "10px 0px 0px 4px" }}>{x.celular }</td>
                                    <td style={{ padding: "10px 0px 0px 4px" }}>{x.nombreSeguro}</td>
                                    <td style={{ padding: "10px 0px 0px 4px" }}>{x.poliza }</td>
                                    <td style={{ padding: "0px" }}>
                                        <textarea  cols="30" value={x.historiaClinica} disabled></textarea>

                                        </td>
                                </tr>
                            ))}

                        </table>

                        {/*<table>*/}
                        {/*    <tr>*/}
                        {/*        {a[0].map((x, index) => (<th>{ x}</th>) )}*/}
                        {/*    </tr>*/}
                        
                        {/*    {b.map((x,index) => (<tr>*/}
                        {/*        <td>{x[0]}</td>*/}
                        {/*        <td>{x[1]}</td>*/}
                        {/*        <td>{x[2]}</td>*/}
                        {/*        <td>{x[3]}</td>*/}
                        {/*        <td>{x[4]}</td>*/}
                        {/*        <td>{x[5]}</td>*/}
                        {/*        <td>{x[6]}</td>*/}
                        {/*    </tr>))}*/}
                         
                        {/*</table>*/}
                  
                    </CardBody>
                </Card>
            </Col>
            
        

         
        </>
    )

}
export default ReportesGastro;